import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
export default function NailPoints() {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
            window.matchMedia("(min-width: 1280px)").matches
          );
           useEffect(() => {
              const mediaQuery = window.matchMedia("(min-width: 1280px)");
              const handleChange = (e) => setIsLargeScreen(e.matches);
              mediaQuery.addEventListener("change", handleChange);
          
              return () => {
                mediaQuery.removeEventListener("change", handleChange);
              };
            }, []);
    const points = [
      {
        text: "Fully Implantable: No external pins or hardware — promoting faster recovery and fewer complications.",
        icon: <FaCheckCircle color="#FFFFFF" />, 
      },
      {
        text: "Smart External Controller: Easily programmable by the physician to automate daily distractions, ensuring accurate and hassle-free patient use.",
        icon: <FaCheckCircle color="#FFFFFF" />, 
      },
      {
        text: "Weight-Bearing Design: Supports early mobilization and load-bearing, enhancing post-operative recovery.",
        icon: <FaCheckCircle color="#FFFFFF" />, 

      },
      {
        text: "Custom-Fit for Indian Physiology: Our nails are available in sizes optimized for Indian patient anatomies — a key limitation in many imported systems.",
        icon: <FaCheckCircle color="#FFFFFF" />,  
      },
      {
        text: "Infection Control: With everything internal, the chance of infection drops drastically compared to external fixator-based systems.",
        icon: <FaCheckCircle color="#FFFFFF" />,   
      },
    ];
  
  return (
    <>{isLargeScreen&&
      <div className="d-flex flex-column bg-gray-light justify-content-evenly m-0 upy-3">
      <div className="bg-dark-blue text-white upy-3">
        <p className="text-center fw-bold ufs-7 m-0">Why Our System Stands Apart</p>
      </div>
      <div className="upy-10 upx-10 m-0 w-100 bg-gray-light">
        <div className="d-flex position-relative">
          <ul
            className="bg-gray-light"
            style={{
              listStyle: "none", 
            }}
          >
            {points.map((point, index) => (
              <li
                key={index}
                className="d-flex align-items-center fw-bold ufs-5 text-gray umy-8 upx-8 upy-5 br-5 box-shadow"
                style={{
                  position: "relative", 
                  overflow: "hidden", 
                }}
              >
                {/* Colored Background */}
                <div className="position-absolute top-0 start-0 bg-dark-blue uw-25 " 
                  style={{ 
                     height: "100%",  
                  }}
                ></div>

                {/* Icon */}
                <span className=" d-flex justify-content-center align-items-center uw-12 uh-15 ufs-10 m-0 upr-3 z-1 ">
                  {point.icon}
                </span>

                {/* Text */}
                <span className=" upl-12 z-2">
                  {point.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    }{!isLargeScreen&&
      <div className="d-flex flex-column bg-gray-light justify-content-evenly m-0 upy-3">
      <div className="bg-dark-blue text-white upy-3">
        <p className="text-center fw-bold fs-4 m-0">Why Our System Stands Apart</p>
      </div>
      <div className="up-10 m-0 w-100 bg-gray-light">
        <div className="d-flex position-relative">
          <ul
            className="bg-gray-light m-0 p-0"
            style={{
              listStyle: "none", 
            }}
          >
            {points.map((point, index) => (
              <li
                key={index}
                className="d-flex align-items-center fw-bold ufs-9 text-gray umy-8 mx-0 upx-8 upy-5 br-5 box-shadow"
                style={{
                  position: "relative", 
                  overflow: "hidden", 
                }}
              >
                <div className="position-absolute top-0 start-0 bg-dark-blue m-0 p-0 uw-10 " 
                  style={{ 
                     height: "100%",  
                  }}
                ></div>
              
                {/* Text */}
                <span className=" upl-12 z-2">
                  {point.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    }</>
       
      
    
  )
}
